import React from "react";
import { Table } from "reactstrap";
import { object } from "prop-types";
import "./scorecardCalculatedParametersTable.css";
import { getRiskColor } from "../../../../../utilities/riskColor";

const ScorecardCalculatedParametersTable = ({ singleClientReportDetails }) => {
  const rows = singleClientReportDetails.scoreValueOfEachParameter.map(
    (entry) => {
      const valueStyles = {
        color: getRiskColor({ key: entry.scoreCardRiskProfileName }),
      };

      return (
        <tr key={entry.scoreCardRiskFactorName}>
          <td className="font-weight-bolder">{entry.scoreCardRiskFactorName}</td>
          <td>{entry.clientParamValue}</td>
          <td style={valueStyles}>{entry.scoreCardRiskProfileName}</td>
        </tr>
      );
    }
  );

  return (
    <Table className="single-client-report-entries-table-score-calculated">
      <thead>
        <tr>
          <th>{singleClientReportDetails.riskFactorLabel}</th>
          <th>{singleClientReportDetails.parameterValueLabel}</th>
          <th>{singleClientReportDetails.riskProfileLabel}</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
      <tfoot />
    </Table>
  );
};
ScorecardCalculatedParametersTable.propTypes = {
  singleClientReportDetails: object.isRequired,
};

export default ScorecardCalculatedParametersTable;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/scorecard-calculated-parameters-table/ScorecardCalculatedParametersTable.jsx